/* ÁGUAS DE IPANEMA — kit de peças iguais: a ORDEM dos seletores não importa

   "Kit 3 Bases" tem três Base Stick. A variante "Stick 10 / Stick 30 / Stick 60"
   e "Stick 60 / Stick 30 / Stick 10" são o mesmo kit: as mesmas três bases, na
   mesma caixa. O catálogo guarda UMA variante por trio (ordem não-decrescente),
   porque as 343 permutações estourariam o teto de 250 variantes da vitrine.

   Sem isso o seletor nativo não acha a combinação pedida e cai no "mais próximo
   disponível": quem pede 60/20/10 recebe 60/60/60 — três bases iguais, um kit
   que ninguém escolheu, e sem aviso nenhum. Medido na PDP em 13/09/2026.

   A regra: o trio pedido é procurado como CONJUNTO, e a tela passa a mostrar a
   variante que existe. Assim o que está marcado é sempre o que vai para o
   carrinho — nenhum tom escolhido se perde, só a posição é reordenada, e
   posição aqui não quer dizer nada (as três peças são o mesmo produto).

   Não mexe em estoque, preço, variantes, SKU nem na composição do kit: só
   traduz o trio escolhido para a variante equivalente que já está cadastrada. */
(function () {
  if (window.__aipKitOrdemLivre) return;
  window.__aipKitOrdemLivre = true;

  var CAIXA = '.product-form__variants';

  function radios() {
    return Array.prototype.slice.call(
      document.querySelectorAll(CAIXA + ' input[type="radio"][name^="option"]')
    );
  }

  function indice(r) {
    var n = parseInt(String(r.name).replace(/\D+/g, ''), 10);
    return isNaN(n) ? -1 : n - 1;
  }

  function escolhaAtual(n) {
    var sel = new Array(n);
    radios().forEach(function (r) { if (r.checked) sel[indice(r)] = r.value; });
    return sel;
  }

  function chave(o) { return o.slice().sort().join(' '); }

  /* posições que oferecem exatamente os mesmos valores = peças iguais */
  function pecasIguais(vars, nOpts) {
    if (nOpts < 2 || !vars.length) return false;
    var conj = [];
    for (var i = 0; i < nOpts; i++) conj.push({});
    vars.forEach(function (v) {
      v.options.forEach(function (val, i) { if (conj[i]) conj[i][val] = true; });
    });
    var ref = Object.keys(conj[0]).sort().join(' ');
    for (var j = 1; j < nOpts; j++) {
      if (Object.keys(conj[j]).sort().join(' ') !== ref) return false;
    }
    return true;
  }

  /* marca os rádios sem disparar change: quem dispara é o clique da pessoa */
  function pintar(sel) {
    radios().forEach(function (r) {
      var i = indice(r);
      if (i < 0 || sel[i] == null) return;
      r.checked = (r.value === sel[i]);
      var cx = r.closest('.color-swatch') || r.parentElement;
      if (cx) cx.classList.toggle('is-selected', r.checked);
    });
  }

  var estado = null;

  function preparar() {
    var pv = document.querySelector('product-variants');
    if (!pv || !document.querySelector(CAIXA)) return;
    var handle = pv.getAttribute('handle');
    if (!handle) return;

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.variants || !d.options) return;
        var nOpts = d.options.length;
        if (!pecasIguais(d.variants, nOpts)) return;   /* kit comum: nada a fazer */

        var porConjunto = {}, exatas = {};
        d.variants.forEach(function (v) {
          exatas[v.options.join(' ')] = true;
          var k = chave(v.options);
          if (!porConjunto[k]) porConjunto[k] = v;
        });
        estado = { nOpts: nOpts, porConjunto: porConjunto, exatas: exatas };
      })
      .catch(function () {});
  }

  /* Antes do tema resolver: reordena o trio pedido para a ordem em que ele
     existe no catálogo. O tema então encontra a combinação exata e cuida
     sozinho de preço, mídia, disponibilidade e URL — nada aqui reimplementa o
     que ele já faz. */
  document.addEventListener('change', function (e) {
    if (!estado) return;
    var r = e.target;
    if (!r || r.type !== 'radio' || !r.closest || !r.closest(CAIXA)) return;
    var i = indice(r);
    if (i < 0) return;

    /* Ler o DOM é seguro: o que está marcado é sempre a variante de verdade,
       porque a tela nunca fica numa ordem que não existe. */
    var pedido = escolhaAtual(estado.nOpts);
    pedido[i] = r.value;
    for (var k = 0; k < estado.nOpts; k++) if (pedido[k] == null) return;

    /* A combinação pedida existe exatamente como foi pedida? Então é ela, e
       nada aqui se mete. É o caso do Combo Stick 3 em 1, que tem as 27
       permutações cadastradas: reordenar ali trocava o tom de uma peça sem
       motivo nenhum. Só quando a ordem pedida NÃO existe é que vale procurar
       o mesmo trio na ordem em que ele foi cadastrado. */
    if (estado.exatas[pedido.join(' ')]) return;

    var v = estado.porConjunto[chave(pedido)];
    if (!v) return;                                        /* trio sem variante: o tema decide */

    pintar(v.options);
  }, true);

  document.addEventListener('DOMContentLoaded', preparar);
  if (document.readyState !== 'loading') preparar();
})();
